export class Prescription {
    prescription_id?: number;
    doctor_guid?: string;
    medication_name: string;
    dosage: string;
    times_per_day: string;
    no_of_refills: number;
    comments?: string;
    created_at?: Date;
}

// export class PrescriptionCreate {
//     // consultation_id: number;
//     // patient_guid: string;
//     // user_guid: string;
//     medication_name: string;
//     dosage: string;
//     times_per_day: number;
//     no_of_days: number;
// }

// export class PrescriptionDelete{
//     prescription_id:number;
//     consultation_id: number;
//     patient_guid:string;
// }

export class Prescriptions {
    id: number = null;
    medication_name: string = '';
    dosage: string = '';
    times_per_day: any = '';
    no_of_refills: number = null;
    comments: string = '';
    advice: string = '';
    recommendations: string = '';
}
